import { Component, OnInit } from '@angular/core';
import { SystemUser } from '../system-user';
import { HttpService } from '../service/http.service';
import { FaviconService } from '../favicon.service';
import { LoginService } from '../security/login.service';
import { UserForBackend } from '../user-for-backend';

@Component({
  selector: 'app-system-users',
  templateUrl: './system-users.component.html',
  styleUrls: ['./system-users.component.css']
})
export class SystemUsersComponent implements OnInit {

  users: UserForBackend[] = [];

  constructor(
    private httpService: HttpService,
    private favicon: FaviconService,
    private loginService: LoginService
  ) {
    this.loginService.activatedNavigationComponent = true;
    this.favicon.sbms();
   }

  ngOnInit() {
    this.httpService.getActiveUsers().subscribe(res =>{
      this.users = res;
    });
  }

  isAdmin(user: UserForBackend){
    for(let role of user.roles){
      if(role == "admin"){
        return true;
      }
    }
    return false;
  }

}
